import servicioBase from '@/services/servicio-base'

const servicio = {}

servicio.consultarFoliosCobranza = function(fechaInicio, fechaFin, pagina){
    return servicioBase.post('/cobranza/general/referenciar-pagos/consultar-folios', {FechaInicio: fechaInicio,FechaFin: fechaFin, Pagina:pagina})
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}

servicio.imprimirRecibo = function(folio, codAgente){
    return servicioBase.get(`/cobranza/general/referenciar-pagos/imprimir-recibo/${folio}/${codAgente}`)
        .then(r => {
            return r.data
        })
        .catch(error => {
            return error
        })
}
export default servicio